import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory, RentalObjectCategoryToString } from './../../model/const/enums';
import { RentalObjectType } from './../../model/rental-object-type';
import { RentalObjectTypeService } from './../../service/data/rental-object-type.service';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';

@Component({
    selector: 'app-rental-object-type',
    templateUrl: './rental-object-type-form.component.html',
    providers: [
        DeleteFormCommandHandler,
        FormCommandHandlerResolver,
        NavigationService,
        { provide: DataService, useExisting: RentalObjectTypeService },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectTypeFormComponent extends FormComponentBase<RentalObjectType> {
  constructor(
    private fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    dispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    service: RentalObjectTypeService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, dispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  categories = [
    { name: RentalObjectCategoryToString(RentalObjectCategory.Dwelling), value: RentalObjectCategory.Dwelling },
    { name: RentalObjectCategoryToString(RentalObjectCategory.Parking), value: RentalObjectCategory.Parking },
    { name: RentalObjectCategoryToString(RentalObjectCategory.Premises), value: RentalObjectCategory.Premises },
    { name: RentalObjectCategoryToString(RentalObjectCategory.Other), value: RentalObjectCategory.Other },
  ];

  getFormGroup(): FormGroup {
    return this.fb.group({
      category: this._fc.createWithOptions('RENTAL_OBJECT_TYPE_FORM.CATEGORY_LABEL', this.dataContext.category, {
        isReadonly: !this.dataContext.isNew,
        required: true,
      }),
      name: this._fc.createWithOptions('RENTAL_OBJECT_TYPE_FORM.NAME_LABEL', this.dataContext.name, { length: 50, required: true }),
      numberOfRooms: this._fc.create('RENTAL_OBJECT_TYPE_FORM.NUMBER_OF_ROOMS_LABEL', this.dataContext.numberOfRooms),
      rH91: this._fc.create('RENTAL_OBJECT_TYPE_FORM.RH91', this.dataContext.rH91),
      pointsBvk91: this._fc.create('RENTAL_OBJECT_TYPE_FORM.BVK91', this.dataContext.pointsBvk91),
      isGarage: this._fc.create('RENTAL_OBJECT_TYPE_FORM.ISGARAGE_LABEL', this.dataContext.isGarage),
      parkingHasElectricity: this._fc.create('RENTAL_OBJECT_TYPE_FORM.PARKINGHASELECTRICITY_LABEL', this.dataContext.parkingHasElectricity),
      parkingHasRoof: this._fc.create('RENTAL_OBJECT_TYPE_FORM.PARKINGHASROOF_LABEL', this.dataContext.parkingHasRoof),
    });
  }

  showNumberOfRooms(): boolean {
    return this.form.value.category == RentalObjectCategory.Dwelling;
  }

  showRH91(): boolean {
    return this.form.value.category == RentalObjectCategory.Dwelling;
  }

  showBVK91(): boolean {
    return this.form.value.category == RentalObjectCategory.Dwelling;
  }

  isObjectTypeParking(): boolean {
    return this.form.value.category == RentalObjectCategory.Parking;
  }

  protected createModel(): RentalObjectType {
    return new RentalObjectType();
  }
}
